module.exports = "/_next/static/images/card-prepaid-664d4453464370e219699f24b4f3c2ce.svg";